function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Tooltip, Input, TitleComponent } from '@keen.io/ui-core';
import { Container, TooltipContainer } from './Percentile.styles';
import { getPercentileValue } from './utils/getPercentileValue';
import { HIDE_TIME } from './constants';
export var tooltipMotion = {
  transition: {
    duration: 0.3
  },
  exit: {
    opacity: 0
  }
};

var Percentile = function Percentile(_ref) {
  var value = _ref.value,
      onReset = _ref.onReset,
      onChange = _ref.onChange;
  var containerRef = useRef(null);
  var hideTooltip = useRef(null);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      tooltip = _useState2[0],
      setTooltip = _useState2[1];

  useEffect(function () {
    return function () {
      return onReset();
    };
  }, []);
  var changeHandler = useCallback(function (eventValue) {
    if (eventValue.target.value) {
      var percentile = parseInt(eventValue.target.value);

      var _getPercentileValue = getPercentileValue(percentile),
          _value = _getPercentileValue.value,
          outRange = _getPercentileValue.outRange;

      onChange(_value);
      if (hideTooltip.current) clearTimeout(hideTooltip.current);
      setTooltip(outRange);
      hideTooltip.current = setTimeout(function () {
        setTooltip(false);
      }, HIDE_TIME);
    } else {
      onReset();
    }
  }, [onChange, onReset]);
  return React.createElement(Container, {
    ref: containerRef
  }, React.createElement(AnimatePresence, null, tooltip && React.createElement(TooltipContainer, Object.assign({}, tooltipMotion, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    }
  }), React.createElement(Tooltip, {
    mode: "dark",
    hasArrow: false
  }, t('query_creator_percentile.message')))), React.createElement(TitleComponent, null, t('query_creator_percentile.label')), React.createElement(Input, {
    type: "number",
    variant: "solid",
    value: value ? value : '',
    placeholder: t('query_creator_percentile.placeholder'),
    onChange: function onChange(e) {
      return changeHandler(e);
    }
  }));
};

export default Percentile;